<template>
  <b-form-group
    :label="$t('fields.project')"
    label-for="id_projects"
  >
    <v-select
      v-model="dataItem.id_projects"
      :options="projectsList"
      label="title"
      :reduce="item => item.id"
      :placeholder="$t('tasks.form.projectPlaceholder')"
      clearable
    />
    <small
      v-if="isClosedProject"
      class="text-warning"
    >
      {{ $t('tasks.form.closedProject') }}
    </small>
  </b-form-group>
</template>

<script>
import { BFormGroup } from 'bootstrap-vue'
import vSelect from 'vue-select'
import { definitionId } from '@/libs/definitions'

export default {
  name: 'TasksProjectsCard',
  components: { BFormGroup, vSelect },
  computed: {
    projectsList() {
      return this.$store.getters['projects/dataList']
    },
    dataItem() {
      return this.$store.getters['tasks/dataItem']
    },
    isClosedProject() {
      const project = this.projectsList.find(item => Number(item.id) === Number(this.dataItem.id_projects))
      return !!project && Number(project.is_public) === 0
    },
  },
  created() {
    this.getOpenProjects()
  },
  methods: {
    getOpenProjects() {
      this.$store.dispatch('projects/getDataList', {
        select: ['projects.id AS id', 'projects.title AS title', 'projects.is_public AS is_public'],
        where: { 'projects.id_project_statuses': definitionId('project', 'open') },
        limit: 500,
        start: 0,
      })
    },
  },
}
</script>
